module.exports = __webpack_public_path__ + "static/media/record-btn.6be9e7d4.png";